<template>
    <div>
        <div class="banner">
            <div class="headerReplacementDebtInfo"></div>
            <div class="banner-text">
                <b>{{ $t('debtInfo.pageTitle') }}</b>
                <div class="breadcrumb">
                    <span><router-link to="/" class="pe-auto">{{ $t('debtInfo.breadcrumbHome') }}</router-link></span>
                    <span class="separator"></span>
                    <span>{{ $t('debtInfo.pageTitle') }}</span>
                    <span class="separator"></span>
                    <span><b>{{ $t('debtInfo.pageTitle') }}</b></span>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="TabMenu">
                <DebtInfoTabMenu />
            </div>
            <div class="table-responsive">
                <table class="table mt-3 mb-5">
                    <thead>
                        <tr class="table-secondary text-center">
                            <th scope="col"><b>{{ $t('debtInfo.table.symbol') }}</b></th>
                            <th scope="col"><b>{{ $t('debtInfo.table.issuedSize') }}</b></th>
                            <th scope="col"><b>{{ $t('debtInfo.table.outstanding') }}</b></th>
                            <th scope="col"><b>{{ $t('debtInfo.table.issueDate') }}</b></th>
                            <th scope="col"><b>{{ $t('debtInfo.table.maturityDate') }}</b></th>
                            <th scope="col"><b>{{ $t('debtInfo.table.term') }}</b></th>
                            <th scope="col"><b>{{ $t('debtInfo.table.interestRate') }}</b></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">ORI254A</th>
                            <td class="text-center">2,965.0</td>
                            <td class="text-center">2,965.0</td>
                            <td class="text-center">27 เมษายน 2565</td>
                            <td class="text-center">27 เมษายน 2568</td>
                            <td class="text-center">3 ปี</td>
                            <td class="text-center">3.90%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI249A</th>
                            <td class="text-center">807.8</td>
                            <td class="text-center">807.8</td>
                            <td class="text-center">1 กันยายน 2565</td>
                            <td class="text-center">1 กันยายน 2567</td>
                            <td class="text-center">2 ปี</td>
                            <td class="text-center">3.50%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI259A</th>
                            <td class="text-center">982.2</td>
                            <td class="text-center">982.2</td>
                            <td class="text-center">1 กันยายน 2565</td>
                            <td class="text-center">1 กันยายน 2568</td>
                            <td class="text-center">3 ปี</td>
                            <td class="text-center">3.95%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI269A</th>
                            <td class="text-center">714.7</td>
                            <td class="text-center">714.7</td>
                            <td class="text-center">1 กันยายน 2565</td>
                            <td class="text-center">1 กันยายน 2569</td>
                            <td class="text-center">4 ปี</td>
                            <td class="text-center">4.25%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI273A</th>
                            <td class="text-center">700.0</td>
                            <td class="text-center">700.0</td>
                            <td class="text-center">22 มีนาคม 2566</td>
                            <td class="text-center">22 มีนาคม 2570</td>
                            <td class="text-center">4 ปี</td>
                            <td class="text-center">4.45%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI249B</th>
                            <td class="text-center">600.0</td>
                            <td class="text-center">600.0</td>
                            <td class="text-center">22 มีนาคม 2566</td>
                            <td class="text-center">22 กันยายน 2567</td>
                            <td class="text-center">1.5 ปี</td>
                            <td class="text-center">3.25%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI263A</th>
                            <td class="text-center">1,200.0</td>
                            <td class="text-center">1,200.0</td>
                            <td class="text-center">22 มีนาคม 2566</td>
                            <td class="text-center">22 มีนาคม 2569</td>
                            <td class="text-center">3 ปี</td>
                            <td class="text-center">4.15%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI267A</th>
                            <td class="text-center">2,067.9</td>
                            <td class="text-center">2,067.9</td>
                            <td class="text-center">11 กรกฎาคม 2566</td>
                            <td class="text-center">11 กรกฎาคม 2569</td>
                            <td class="text-center">3 ปี</td>
                            <td class="text-center">4.40%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI277A</th>
                            <td class="text-center">955.6</td>
                            <td class="text-center">955.6</td>
                            <td class="text-center">11 กรกฎาคม 2566</td>
                            <td class="text-center">11 กรกฎาคม 2570</td>
                            <td class="text-center">4 ปี</td>
                            <td class="text-center">4.60%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI248A</th>
                            <td class="text-center">500.0</td>
                            <td class="text-center">500.0</td>
                            <td class="text-center">30 สิงหาคม 2566</td>
                            <td class="text-center">30 สิงหาคม 2567</td>
                            <td class="text-center">1 ปี</td>
                            <td class="text-center">3.45%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI259B</th>
                            <td class="text-center">1,000.0</td>
                            <td class="text-center">1,000.0</td>
                            <td class="text-center">16 มกราคม 2567</td>
                            <td class="text-center">1 กันยายน 2568</td>
                            <td class="text-center">1.6 ปี</td>
                            <td class="text-center">4.25%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI271A</th>
                            <td class="text-center">780.5</td>
                            <td class="text-center">780.5</td>
                            <td class="text-center">16 มกราคม 2567</td>
                            <td class="text-center">16 มกราคม 2570</td>
                            <td class="text-center">3 ปี</td>
                            <td class="text-center">4.85%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI27NA</th>
                            <td class="text-center">623.3</td>
                            <td class="text-center">623.3</td>
                            <td class="text-center">14 พฤษภาคม 2567</td>
                            <td class="text-center">14 พฤศจิกายน 2570</td>
                            <td class="text-center">3.5 ปี</td>
                            <td class="text-center">5.00%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI275A</th>
                            <td class="text-center">941.7</td>
                            <td class="text-center">941.7</td>
                            <td class="text-center">14 พฤษภาคม 2567</td>
                            <td class="text-center">14 พฤษภาคม 2570</td>
                            <td class="text-center">3 ปี</td>
                            <td class="text-center">4.85%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI263B</th>
                            <td class="text-center">935.0</td>
                            <td class="text-center">935.0</td>
                            <td class="text-center">14 พฤษภาคม 2567</td>
                            <td class="text-center">22 มีนาคม 2569</td>
                            <td class="text-center">1.85 ปี</td>
                            <td class="text-center">4.25%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI288A</th>
                            <td class="text-center">454.9</td>
                            <td class="text-center">454.9</td>
                            <td class="text-center">9 สิงหาคม 2567</td>
                            <td class="text-center">9 สิงหาคม 2571</td>
                            <td class="text-center">4 ปี</td>
                            <td class="text-center">5.15%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI282A</th>
                            <td class="text-center">430.3</td>
                            <td class="text-center">430.3</td>
                            <td class="text-center">9 สิงหาคม 2567</td>
                            <td class="text-center">9 กุมภาพันธ์ 2571</td>
                            <td class="text-center">3.5 ปี</td>
                            <td class="text-center">5.00%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI278A</th>
                            <td class="text-center">317.4</td>
                            <td class="text-center">317.4</td>
                            <td class="text-center">9 สิงหาคม 2567</td>
                            <td class="text-center">9 สิงหาคม 2570</td>
                            <td class="text-center">3 ปี</td>
                            <td class="text-center">4.85%</td>
                        </tr>
                        <tr>
                            <th scope="row"><b>{{ $t('debtInfo.table.total') }}</b></th>
                            <td class="text-center"><b>16,976.3</b></td>
                            <td class="text-center"><b>16,976.3</b></td>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
  
<script>
import DebtInfoTabMenu from '@/components/DebtInfoTabMenu.vue';
import Highcharts from 'highcharts';
import store from "@/store";
import { mapState } from "vuex";
import { GET_FINANCIAL_DATA } from "../../store/actions.type";

export default {
    name: 'Info',
    components: {
        DebtInfoTabMenu,
    },
    data() {
        return {
            financialData: null,
        };
    },
    methods: {
        async init() {
            let response = await store.dispatch(GET_FINANCIAL_DATA);
            if (response) {
                this.financialData = response; // Assign fetched data to local state
            } else {
                console.error('Failed to fetch financial data');
            }
        },
    },

};
</script>
<style scoped>
th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}

.table th {
    font-size: 0.85rem;
    font-weight: normal;
    padding: 8px;
}
</style>
  